export default __webpack_public_path__ + "bbe91b55437ea36d2a1a592da3960b50.svg";